import { atom } from "jotai";
import type { AuthSession } from "../types";

/**
 * Cookie-based auth: the HttpOnly `eriol_session_admin` cookie holds the
 * credential. We can't read it from JS (that's the point), so frontend state
 * only holds the user profile fetched from /auth/me. No sessionStorage
 * persistence — the cookie survives reload, the /me call rehydrates the
 * user atom on mount.
 */

export type AuthUser = AuthSession["user"];

export const authUserAtom = atom<AuthUser | null>(null);

export const authStatusAtom = atom<
  "checking" | "authenticated" | "unauthenticated"
>("checking");
